import { useEffect, useState } from "react";
import { Typography, Menu } from "antd";
import Localize from "../../utils/string";
import NewPassword from "../../components/emailAndPassword";
import Orders from "../../components/orders";
import { resetStore, setLoading } from "../../store/common/commonActions";
import { useDispatch, useSelector } from "react-redux";
import { DownArrow } from "../../assets/images";
import BasicInfo from "../../components/profile/basicInfo";
import AccountInfo from "../../components/profile/accountInfo";
import ShippingAddressInfo from "../../components/profile/shippingAddressInfo";
import BillingAddressInfo from "../../components/profile/billingAddressInfo";
import ContactInfo from "../../components/profile/contactInfo";
import {
  getCustomerData,
  getCustomerOrder,
  getOrders,
} from "../../store/common/commonAsyncAction";

import { ProductsMdl } from "../../Modal/Products";
import moment from "moment";
import { useHistory } from "react-router";
import { CartDetailShow } from "../../store/products/productsAsyncActions";

const { SubMenu } = Menu;

const columns = [
  {
    title: "ORDER DATE",
    dataIndex: "orderDate",
    key: "orderDate",
    render: (value?: any, row?: any) => {
      return <>{moment(value).format("DD/MM/YYYY")}</>;
    },
  },
  {
    title: "ORDER NUMBER",
    dataIndex: "orderNo",
    key: "orderNo",
  },
  {
    title: "DELIVER TO ADDRESS",
    dataIndex: "deliverToAddress",
    key: "deliverToAddress",
  },
  {
    title: "INVOICE DATE",
    dataIndex: "invoicedDate",
    key: "invoicedDate",
  },
  {
    title: "TOTAL",
    dataIndex: "totalAmount",
    key: "totalAmount",
    render: (value: any) => {
      return <>{value?.toFixed(2)}</>;
    },
  },
];

const Setting = () => {
  const loginResp = useSelector((state: any) => state.user.userSession);
  const customerData = useSelector((state: any) => state.common.customerData);
  const CartOrderData: any = useSelector(
    (state: any) => state.products.CartOrderData
  );
  const [selectedKey, setSelectedKey] = useState("1");
  const [CustomerData, setCustomerData] = useState({} as any);
  const [customerOrderData, setCustomerOrderData] = useState([] as any);
  const [orderDate, SetOrderDate] = useState("");
  const [myOrderData, setMyOrderData] = useState([] as any);
  const dispatch = useDispatch();
  const history = useHistory();
  const handleClick = (e: any) => {
    setSelectedKey(e.key);
  };

  useEffect(() => {
    if (customerData) {
      dispatch(setLoading(true));
      const CustomerData = customerData.data?.[0];
      setCustomerData(CustomerData);
    }
  }, [customerData?.data]);

  useEffect(() => {
    const fetchData = async () => {
      const query = `?customerId=${loginResp.userId}&customerEmail=${loginResp.email}`;
      await dispatch(getCustomerData(query));
      const responseOfOrder: any = await dispatch(getCustomerOrder());

      // if (CartOrderData?.customerId) {
      const params: any = {
        OrderId: CartOrderData?.orders?.[0]?.id,
        CustomerId: CartOrderData?.customerId,
      };

      const query1 = `?customerId=${loginResp?.userId}`;

      const responseOfOrders: any = await dispatch(getOrders(query1));
      if (responseOfOrders) {
        setMyOrderData(responseOfOrders?.data);
      }

      // }

      if (responseOfOrder?.data) setCustomerOrderData(responseOfOrder?.data);
      responseOfOrder?.data?.map((element: any) => {
        const { orderDateTime } = element;

        const cutOffDate = moment(orderDateTime).format("DD/MM/YYYY");
        SetOrderDate(cutOffDate);
      });
    };
    if (loginResp) {
      dispatch(setLoading(true));
      fetchData();
    }
  }, [loginResp]);
  useEffect(() => {
    scrollToTop();
    const fetchData = async () => {
      if (loginResp?.userId) {
        const Qparams: any = `?customerId=${loginResp?.userId}`;
        const response: any = await dispatch(CartDetailShow(Qparams));
      }
    };
    fetchData();
  }, []);
  useEffect(() => {
    componentsSwtich();
  }, [selectedKey]);
  
const scrollToTop = () => {
    const top = document.getElementById("top") as HTMLElement;
    top.scrollIntoView(); 
};
  const componentsSwtich = () => {
    if (selectedKey === "11") {
      dispatch(resetStore());
      history.push("login");
    }

    switch (selectedKey) {
      case "1":
        return <BasicInfo title="Basic Information" data={CustomerData} />;
      // case '3':
      //     return (<AccountInfo title="Account No. Information" data={CustomerData} />);
      case "4":
        return (
          <ShippingAddressInfo
            title="Shipping Address Info"
            data={CustomerData}
          />
        );
      case "5":
        return (
          <BillingAddressInfo
            title="Billing Address Info"
            data={CustomerData}
          />
        );
      case "6":
        return <ContactInfo title="Contact Info" data={CustomerData} />;
      case "7":
        return <NewPassword />;
      case "8":
        return (
          <Orders
            title="Pre-Sale Order"
            dataSource={customerOrderData}
            columns={columns}
          />
        );
      case "9":
        return (
          <Orders
            title="Previous Order"
            dataSource={customerOrderData}
            columns={columns}
          />
        );
      case "10":
        return (
          <Orders
            title="My Orders"
            dataSource={myOrderData}
            columns={columns}
          />
        );
      default:
        break;
    }
  };
  return (
    <div className="setting" id="top">
      <div className="container-fluid">
        <div className="setting-menu">
          <div className="menu">
          <Typography.Title className="setting-heading" level={4}>
            {Localize.AccountTitle}{" "}
          </Typography.Title>
            <Menu
              onClick={handleClick}
              style={{ width: 256 }}
              defaultSelectedKeys={["1"]}
              mode="inline"
            >
              <SubMenu
                key="sub1"
                title={
                  <span className="account-setting-tab">
                    Profile
                    <DownArrow />
                  </span>
                }
              >
                <Menu.Item key="1">Basic Information</Menu.Item>
                {/* <Menu.Item key="3">Account No. Information</Menu.Item> */}
                <Menu.Item key="4">Shipping Address Info</Menu.Item>
                <Menu.Item key="5">Billing Address Info</Menu.Item>
                <Menu.Item key="6">Contact Info</Menu.Item>
              </SubMenu>
              <Menu.Item key="7">{Localize.ChangePassword}</Menu.Item>

              {/* <SubMenu key="sub2" title={<span className="account-setting-tab">My Orders<DownArrow /></span>}>
                              <Menu.Item key="8">Pre-Sale Order</Menu.Item>
                              <Menu.Item key="9">Previous Order</Menu.Item>
                              <Menu.Item key="10">My Orders</Menu.Item>
                          </SubMenu> */}
              <Menu.Item key="11">Logout</Menu.Item>
            </Menu>
          </div>
          <div className="menu-component">{componentsSwtich()}</div>
        </div>
      </div>
    </div>
  );
};

export default Setting;
